export const addWord = {
  // バリデーション
  loginRequired: 'ログインが必要です',
  required: '単語と意味は必須です',
  submitFailed: '投稿に失敗しました。もう一度お試しください。',

  // 送信完了
  doneTitle: '投稿完了！',
  doneBody: '投稿はAdminの承認後に公開されます。<br />しばらくお待ちください。',
  continuePosting: '続けて投稿',
  toWordPool: 'Word Poolへ',

  // ヘッダー
  back: '← Back to Word Pool',
  heading: '単語を投稿する',
  poster: '投稿者: ',

  // ラベル
  languageLabel: '言語 *',
  phraseLabel: '単語 / フレーズ *',
  phrasePlaceholder: '例: おつかれさま',
  readingLabel: '読み方 / 発音',
  readingPlaceholder: '例: Otsukaresama',
  meaningLabel: '意味 (英語) *',
  meaningPlaceholder: '例: Good work today / Thank you for your effort',
  usageLabel: '使い方 / コンテキスト',
  usagePlaceholder: 'どんな場面で使う？',
  lessonDateLabel: 'レッスン日',

  // 送信
  submitting: '投稿中...',
  submit: '投稿する',
  note: '※ 投稿後、Adminの承認を経て公開されます',
};
